/**
 * Sommeert HDS Premium-punten per winkelmandregel via GET /apps/loyalty-points (zelfde contract als loyalty-points-widget).
 */
(function () {
  if (window.__hdsCartPremiumPointsInit) return;
  window.__hdsCartPremiumPointsInit = true;

  var SEL = '[data-hds-cart-premium-root]';
  var DEBOUNCE_MS = 250;
  var debounceTimer = null;

  function formatPoints(sum) {
    var suffix = sum === 1 ? ' punt' : ' punten';
    return '+' + sum.toLocaleString('nl-NL') + suffix;
  }

  /**
   * @param {object} line - /cart.js line item
   * @param {string} currency
   * @param {string} customerEmail
   * @returns {Promise<number|null>}
   */
  function fetchLinePoints(line, currency, customerEmail) {
    var qty = Math.max(1, parseInt(String(line.quantity || 1), 10) || 1);
    var lineTotal = parseInt(String(line.final_line_price != null ? line.final_line_price : line.line_price || 0), 10);
    if (!line.variant_id || isNaN(lineTotal) || lineTotal < 0) {
      return Promise.resolve(null);
    }
    var unitCents = Math.round(lineTotal / qty);
    var url = new URL('/apps/loyalty-points', window.location.origin);
    url.searchParams.set('variant_id', String(line.variant_id));
    url.searchParams.set('price_cents', String(unitCents));
    url.searchParams.set('currency', currency || 'EUR');
    url.searchParams.set('quantity', String(qty));
    if (customerEmail) {
      url.searchParams.set('customer_email', customerEmail);
    }
    if (line.product_id) {
      url.searchParams.set('product_id', String(line.product_id));
    }
    return fetch(url.toString(), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (data) {
        if (!data || data.points === null || data.points === undefined) return null;
        var n = Number(data.points);
        return Number.isFinite(n) ? n : null;
      })
      .catch(function () {
        return null;
      });
  }

  function setAllValues(text) {
    document.querySelectorAll(SEL).forEach(function (root) {
      var el = root.querySelector('[data-hds-cart-premium-value]');
      if (el) el.textContent = text;
    });
  }

  function updateRoots(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var roots = scope.querySelectorAll(SEL);
    if (!roots.length) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) {
          setAllValues('—');
          return;
        }

        var first = roots[0];
        var fromCart = cart.currency;
        var currency =
          (first && first.dataset && first.dataset.currency) ||
          (typeof fromCart === 'string' ? fromCart : fromCart && fromCart.iso_code) ||
          'EUR';
        var customerEmail = (first && first.dataset && first.dataset.customerEmail) || '';

        return Promise.all(
          cart.items.map(function (line) {
            return fetchLinePoints(line, String(currency).toUpperCase(), customerEmail);
          })
        ).then(function (results) {
          var sum = 0;
          var hasAny = false;
          for (var i = 0; i < results.length; i++) {
            if (results[i] != null) {
              sum += results[i];
              hasAny = true;
            }
          }
          setAllValues(hasAny ? formatPoints(sum) : '—');
        });
      })
      .catch(function () {
        setAllValues('—');
      });
  }

  function schedule(root) {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      updateRoots(root);
    }, DEBOUNCE_MS);
  }

  window.hdsRefreshCartPremiumPoints = function (root) {
    schedule(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  document.addEventListener('cart:update', function () {
    schedule();
  });
})();
